enum WithBodyRequests {
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
}

export function isRequireBody(o: unknown): o is ApiQueryWithBodyOptions {
  return (
    o != null &&
    typeof o === 'object' &&
    'method' in o &&
    typeof o.method === 'string' &&
    o.method in WithBodyRequests
  );
}
type ApiQueryBasicOptions<T = unknown> = {
  queryKey: string[];
  apiPath: string;
  headers?: HeadersInit;
  useV2API?: boolean;
  useAlertsAPI?: boolean;
  useArchivistAPI?: boolean;
  enabled?: boolean;
  retry?: number | false;
  isFile?: boolean;
  customFilename?: string;
  select?: (data: T) => unknown;
};

type ApiQueryWithBodyOptions<T = unknown> = ApiQueryBasicOptions<T> & {
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body: NonNullable<unknown>;
};

type ApiQueryWithoutBodyOptions<T = unknown> = ApiQueryBasicOptions<T> & {
  method: 'GET';
};

export type ApiQueryOptions<T = unknown> =
  | ApiQueryWithoutBodyOptions<T>
  | ApiQueryWithBodyOptions<T>;

export type ApiQueryBodyOptions<T = unknown> = ApiQueryWithBodyOptions<T>;

export type ApiMutationOptions = {
  apiPath: string;
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: HeadersInit;
  useV2API?: boolean;
  useAlertsAPI?: boolean;
  useArchivistAPI?: boolean;
  isFileUpload?: boolean;
};
